"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tabs(props) {
  return /*#__PURE__*/_react.default.createElement(_antd.Tabs, props);
}

Tabs.propTypes = {
  /** @ignore */
  animated: _propTypes.default.shape({
    inkBar: _propTypes.default.bool,
    tabPane: _propTypes.default.bool
  })
};
Tabs.defaultProps = {
  animated: {
    inkBar: true,
    tabPane: false
  }
};
var _default = Tabs;
exports.default = _default;